import React from "react";

const PasswordExpirationIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.562"
      height="41.562"
      viewBox="0 0 41.562 41.562"
    >
      <path
        id="db67"
        d="M206.792,177.1a11.936,11.936,0,0,0-11.38,15.338L178.1,209.752l-.99,8.906h7.917l4.453-4.453v-4.947h4.948l1.484-1.484v-4.948h4.948l2.474-2.474a11.884,11.884,0,1,0,3.464-23.255Zm0,8.411a3.463,3.463,0,1,1-3.464,3.464A3.464,3.464,0,0,1,206.792,185.508Z"
        transform="translate(-177.106 -177.096)"
        fill={fill ? fill : "#fb9f34"}
      />
    </svg>
  );
};

export default PasswordExpirationIcon;
